module.exports = __webpack_public_path__ + "media/images/athletes/1463-20784bb5fe1ca5f14c7df2de56be1974.png";